import { useTranslation } from '@presentation/utils';
import { Form } from 'formik';
import type { FC } from 'react';
import {
  Button,
  Card,
  InputField,
  InputLabel,
  InputWrapper,
  Modal,
  ModalCloseButton,
  Section,
  SectionText,
} from '..';
import * as Styled from '../ConfirmationModal/styled';
import type { MtApplicationsBreederRejectModalProps } from './types';

export * from './types';

export const MtApplicationsBreederRejectModal: FC<MtApplicationsBreederRejectModalProps> = (
  props,
) => {
  const { translate } = useTranslation();
  const { modal, isLoading } = props;

  return (
    <Modal {...modal}>
      <Card size="small" isModal>
        <ModalCloseButton modal={modal} />

        <Section>
          <Styled.Container>
            <Styled.ModalSectionTitle>
              {translate('glossary.confirmation')}
            </Styled.ModalSectionTitle>
            <SectionText
              dangerouslySetInnerHTML={{
                __html: translate('common.modals.rejectApplication.text'),
              }}
            />

            <Form>
              <InputWrapper>
                <InputLabel required>{translate('common.inputs.rejectReason.label')}</InputLabel>
                <InputField name="reason" textarea />
              </InputWrapper>

              <Styled.ButtonsContainer>
                <InputWrapper split>
                  <Button color="blue" outlined onClick={modal.onCloseClick}>
                    {translate('common.buttons.cancel')}
                  </Button>
                </InputWrapper>
                <InputWrapper split last>
                  <Button color="blue" type="submit" loading={isLoading} disabled={isLoading}>
                    {translate('common.buttons.confirm')}
                  </Button>
                </InputWrapper>
              </Styled.ButtonsContainer>
            </Form>
          </Styled.Container>
        </Section>
      </Card>
    </Modal>
  );
};
